import { Box, Button } from "@mui/material"

export default function LegendKey({
  label,
  color,
  onClick,
  selected,
}: {
  label: string
  color: string
  onClick?: () => void
  selected?: boolean
}) {
  const content = (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "6px",
        justifyContent: "flex-end",
      }}
    >
      <Box
        sx={{
          width: "12px",
          height: "12px",
          background: color,
          borderRadius: "2px",
        }}
      />
      <span>{label}</span>
    </Box>
  )

  return onClick ? (
    <Button
      onClick={onClick}
      sx={{
        padding: "5px",
        gap: 5,
        minWidth: "auto",
        textTransform: "capitalize",
        color: selected ? "var(--grey-grey-09)" : "var(--grey-grey-06)",
      }}
    >
      {content}
    </Button>
  ) : (
    content
  )
}
